import React from 'react';
import { ZodError } from 'zod';

import styles from './styles.module.css';

interface InputProps {
  type?: 'text' | 'password';
  placeholder?: string;
  value?: string;
  onChange?: (value: string) => void;
  customClass?: string;
  errors?: ZodError[];
  id?: string;
  name?: string;
  autoComplete?: string;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
}

const Input: React.FC<InputProps> = ({
  type = 'text',
  placeholder = '',
  value = '',
  onChange = () => {},
  customClass = '',
  errors = [],
  id = '',
  name = '',
  autoComplete = 'on',
  onKeyDown
}) => {
  const inputClass = errors.length > 0 ? styles.inputError : styles.input;
  return (
    <div className={styles.inputContainer}>
      <input
        id={id}
        name={name}
        autoComplete={autoComplete}
        className={`${inputClass} ${customClass}`}
        type={type}
        placeholder={placeholder}
        value={value || ''}
        onChange={e => onChange(e.target.value)}
        onKeyDown={onKeyDown}
      />
      {errors ? (
        <div className={styles.error}>
          {errors.map(e => e?.message && e.message).join(', ')}
        </div>
      ) : null}
    </div>
  );
};

export default Input;
